import React from 'react'
import CardDetail from '../../../components/comment/carddetailcontent/cardDetailContent'
import CheckBox from "../../../components/comment/checkboxwrap/checkbox";
import { Select, Input, Button } from "antd";

const cardDetail = () => {
  return (
    <div className="card-detail-wrap">
    <div className="row">
        <div className="col-lg-12">
        <div className="rightbar-title">
            Add new debit card details
        </div>
        </div>
    </div>

    <div className="row">
        <div className="col-lg-12">
            <CardDetail />
        </div>
    </div>

    <div className="row">
              <div className="col-lg-12">
              <div className="car-detail-wrap">
              <CheckBox />
            </div>
              </div>
            </div>

            <div className="row ">
              <div className="col-lg-12 ">
                <div className="new-detail-process-btn">
                <Button type="primary">Process</Button>
                </div>
              </div>
            </div>
       

    </div>
  )
}

export default cardDetail